<mat-accordion displayMode="flat">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ sectionTitleText | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <glxy-alert
      type="warning"
      class="alert"
      *ngIf="
        customOutputParamsService.returnKeyValuesArray.dirty &&
        customOutputParamsService.returnKeyValuesArray.errors?.invalidDataType
      "
    >
      {{ 'AUTOMATIONS.EDITOR.RETURN_VALUES.INVALID_DATATYPE' | translate }}
    </glxy-alert>
    <div class="return-values-description">
      {{ descriptionText | translate }}
    </div>
    <div *ngFor="let c of customOutputParamsService.returnKeyValuesArray.controls; let i = index">
      <div [formGroup]="c" class="return-key-values-container">
        <glxy-form-field class="key-name-field">
          <glxy-label>{{ 'AUTOMATIONS.EDITOR.RETURN_VALUES.KEY_NAME' | translate }}</glxy-label>
          <input matInput [formControl]="c.get('keyName')" />
        </glxy-form-field>
        <glxy-form-field class="type-field">
          <glxy-label>{{ 'AUTOMATIONS.EDITOR.RETURN_VALUES.TYPE' | translate }}</glxy-label>
          <mat-select [formControl]="c.get('type')">
            <mat-option *ngFor="let type of dataTypes" [value]="type.value">
              {{ type.nameKey | translate }}
            </mat-option>
          </mat-select>
        </glxy-form-field>
        <button mat-icon-button color="secondary" (click)="customOutputParamsService.removeReturnKeyValue(i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <button mat-button color="primary" (click)="customOutputParamsService.addReturnKeyValue()">
      {{ 'AUTOMATIONS.EDITOR.RETURN_VALUES.ADD_VALUE' | translate }}
    </button>
    <div>
      <div class="payload-header">
        {{ 'AUTOMATIONS.EDITOR.RETURN_VALUES.EXPECTED_PAYLOAD' | translate }}
      </div>
      <div class="payload">
        &#123;<br />
        <ng-container *ngFor="let c of customOutputParamsService.returnKeyValuesArray.controls; let last = last">
          <ng-container *ngIf="c.get('keyName').value; else noValues">
            &nbsp;&nbsp;&nbsp;&nbsp;"{{ c.get('keyName').value }}": "{{
              'AUTOMATIONS.EDITOR.RETURN_VALUES.VALUE' | translate
            }}"
            <ng-container *ngIf="!last">,</ng-container>
            <br />
          </ng-container>
          <ng-template #noValues>
            &nbsp;&nbsp;&nbsp;&nbsp;"{{ 'AUTOMATIONS.EDITOR.RETURN_VALUES.KEY' | translate }}": "{{
              'AUTOMATIONS.EDITOR.RETURN_VALUES.VALUE' | translate
            }}"<br />
          </ng-template>
        </ng-container>
        &#125;<br />
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
